import { init, type LanguageDetectorModule, use } from 'i18next'
import { initReactI18next } from 'react-i18next'
import HttpBackend, { type HttpBackendOptions } from 'i18next-http-backend'
import * as Sentry from '@sentry/react'


// Use a language detector to cache the user's chosen language or fall back to the browser's language
const languageCacheKey = '@cleverev-hub/language'
use<LanguageDetectorModule>({
  type: 'languageDetector',
  init: () => null,
  detect: (): string => {
    const detectedLanguage = navigator.language
    const cachedLanguage = localStorage.getItem(languageCacheKey)

    return cachedLanguage ?? detectedLanguage
  },
  cacheUserLanguage: (language: string): void => {
    localStorage.setItem(languageCacheKey, language)
  }
})

// Use the react-i18next module for react compatibility
use(initReactI18next)

// Default language and namespace
const defaultLng = 'en'
const defaultNS = 'general'

use(HttpBackend)

// Initialize i18next
init<HttpBackendOptions>({
  compatibilityJSON: 'v4',
  defaultNS,
  fallbackLng: defaultLng,
  interpolation: {
    escapeValue: false
  },
  ns: [ defaultNS, 'auth', 'customers', 'partners', 'settings', 'support', 'team', 'chargers', 'keycards', 'personal_keycards', 'stickers' ],

  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json'
  },

  // Alert about missing keys
  missingKeyHandler: (lngs, ns, key) => {
    Sentry.captureEvent({
      message: `Missing i18n key '${key}' in namespace '${ns}' in language(s) ${lngs.map(lng => `'${lng}'`).join(', ')}.`
    })
  }
})

export { defaultLng, defaultNS }
